import { format } from 'date-fns'
import { DELETE, GET, POST, PUT } from '../utils/crud'

const list = async ({ I18n, filters }) => {
  const params = new URLSearchParams()
  if (filters?.page) {
    params.append("page", String(filters.page || 1))
    params.append("size", "10")
  }
  if (filters?.name) {
    params.append("name", filters?.name)
  }
  if (filters?.score?.length) {
    params.append("fragility", filters?.score?.map(item => item.value)?.join(",") || "")
  }
  if (filters?.gender?.length) {
    const genderParam = filters.gender
      .map(item => item.value) // "F", "M"
      .join(",");              // "F,M"

    params.append("gender", genderParam);
  }
  let url = "patients-smart-predict-vdsi"
  if (filters) {
    url = `${url}?${params.toString()}`
  }
  const res = await GET(url)
  const list = filters ? res?.data?.data : res?.data
  const orderData = list?.map((item /* index */) => {
    return {
      id: item?.id,
      name: item?.name,
      lastname: item?.lastname,
      gender: item?.gender,
      age: item?.age || '',
      kforce: item?.k_score,
      system_status: item?.system_status,
      fragilityScore: item?.smart_predict?.fragility_score || null,
      score: item?.smart_predict?.fragility_score?.status
        ? I18n.t(
          `general.fragilityScore.${item?.smart_predict?.fragility_score?.status}`
        )
        : '',
      birthday: item?.birth
        ? format(
          new Date(`${item?.birth}T00:00:00`),
          I18n.t('general.dateFormat')
        )
        : '',
      sex: item?.gender ?? '',
      address: item?.address ?? '',
      phone: item?.phone ?? '',
      dateEnd: item?.smart_predict?.date_tug
        ? format(
          new Date(item?.smart_predict?.date_tug),
          I18n.t('general.dateTimeFormat')
        )
        : '',
      medical_staff: `${item?.smart_predict?.medical_staff?.name ?? ''} ${item?.smart_predict?.medical_staff?.lastname ?? ''
        }`,
      value: item?.vdsi_questions?.[0]?.answer?.value ?? '',
      vdsi: item?.vdsi_questions,
      fragilityIndicators:
        item?.smart_predict?.fragility_indicators?.map((r) => {
          return {
            id: r?.id,
            name: r?.name,
            description: r?.description,
            value: r?.value,
            date: r?.date,
            status: r?.status,
          }
        }) || [],
      homePredictAlerts: item?.smart_predict?.home_predict_alerts || {
        status: '',
        value: '',
      },
      nextAppointmentDate: item?.smart_predict?.next_appointment_date || {
        status: '',
        value: '',
        date: '',
      },
      fragility_date: item?.smart_predict_date,
      tugRisque: item?.smart_predict?.tug_risque || null,
      tugTime: item?.smart_predict?.tug_time || '',
      dateTimeTug: item?.smart_predict?.date_tug || '',
      isTugDocumentSigned: item?.isTugDocumentSigned,
    }
  })
  if (filters) {
    return {
      list: orderData,
      pagination: res?.data?.pagination
    }
  }
  return orderData
}

const detail = async (id) => {
  const res = await GET(`patients/${id}`)
  return res
}

const create = async (body) => {
  const res = await POST('patients', body)
  return res
}

const update = async (id, body) => {
  const res = await PUT(`patients/${id}`, body)
  return res
}

const destroy = async (id) => {
  const res = await DELETE(`patients/${id}`)
  return res
}

const changeStatus = async (id, body) => {
  const res = await POST(`patients/${id}/update-status`, body)
  return res
}

const addCenter = async (id, id_medical_center) => {
  const res = await POST(`patients/${id}/add-medical-center`, {
    id_medical_center,
  })
  return res
}

const associateAll = async (id) => {
  const res = await POST(`patients/${id}/medical-staff-center`)
  return res
}

const addMedicalStaff = async (id, body) => {
  const res = await POST(`patients/${id}/add-medical-staff`, body)
  return res
}

const addOneMedicalStaff = async (id, id_medical_staff) => {
  const res = await POST(`patients/${id}/add-medical-staff`, {
    id_medical_staff: id_medical_staff,
  })
  return res
}
const removeOneMedicalStaff = async (id, id_medical_staff) => {
  const res = await POST(`patients/${id}/remove-medical-staff`, {
    id_medical_staff: id_medical_staff,
  })
  return res
}

const addHealthConditions = async (id, id_health_conditions) => {
  const res = await POST(`patients/${id}/add-health-conditions`, {
    id_health_conditions,
  })
  return res
}

const verifyEmail = async (email) => {
  const res = await GET(`check-email/Patient/${email}`)
  return res
}

const tugTimeGraphic = async (patientId) => {
  const res = await GET(
    'patients-indicators/' + patientId + '/tug-time-graphic'
  )
  return res
}

const documents = async (patientId) => {
  const res = await GET('patient-legal-documents/' + patientId)
  return res
}

const sendEmail = async (id, body) => {
  const res = await POST(`patients-smart-predict/${id}/report`, body)
  return res
}
const sendLegalDocuments = async (id, body) => {
  const res = await POST(`patient-legal-documents/${id}/send-mail`, body)
  return res
}
const sendSmartDetect = async (id, body) => {
  const res = await POST(`patients-kforce/${id}/report`, body)
  return res
}

const documentPatient = async (documentId, patientId) => {
  const res = await GET(
    `legal-documents/${documentId}/preview?patient_id=${patientId}`
  )
  return res
}

const getVDSIList = async (patientId) => {
  const res = await GET(`patient-vdsi?patient_id=${patientId}`)
  return res
}

const sendEmailVdsi = async (id, body) => {
  const res = await POST(`patient-vdsi/${id}/mail`, body)
  return res
}

const getTeleconsultations = async (patientId) => {
  const res = await GET(`teleconsultations?patient_id=${patientId}`)
  return res
}

const getHDM = ({ id, body }) => {
  const res = POST(`historical-smart-predict-patient/${id}/hdm`, body)
  return res
}
const getTokenCertipair = async () => {
  const res = GET('certipair/token')
  return res
}

const getQuestionnaireDates = async (patientId) =>
  await GET(`patient-questionnaires-dates?patient_id=${patientId}`)

const getPatientsFile = async (patientId) =>
  await GET(`patient-files/${patientId}`)

const getMessageHistory = async (patientId) => {
  const res = await GET(
    `certipair/conseils/sended?patient_id=${patientId}`,
    true
  )
  return res
}

const postLoginCartipair = async (body) => {
  const res = await POST('certipair/login', body)

  return res
}

const getSearchConseils = async (body) => {
  const res = await POST(
    `certipair/conseils/search`,
    JSON.stringify(body),
    true,
    {
      'Content-Type': 'application/json',
      'provider-token': `${localStorage.getItem('provider-token')}`,
    }
  )
  return res
}
const getUtilsConseils = async () => {
  const res = await GET(`certipair/utils`, true)
  return res
}

const getConseilsFavorites = async () => {
  const res = await GET(`certipair/conseils/favorites`, true)
  return res
}
const getPatientReports = async ({ reportType = 1, patientId }) => {
  const res = await GET(`reports/bilan-patient?patient_id=${patientId}&report_type=${reportType}`, false, { formatType: "blob", header: { "Content-Type": "application/pdf" } })
  return res
}

const postConseilsSend = async (body) => {
  const res = POST(`certipair/conseils/send`, JSON.stringify(body), true, {
    'Content-Type': 'application/json',
    'provider-token': `${localStorage.getItem('provider-token')}`,
  })
  return res
}

const changeFavorite = async (body) => {
  const res = await POST(`certipair/conseils/fav`, JSON.stringify(body), true, {
    'Content-Type': 'application/json',
    'provider-token': `${localStorage.getItem('provider-token')}`,
  })
  return res
}

const createOmnidoc = async (body) => await POST('omnidoc', body)

export const getPatientList = async () => await GET("patients")

export default {
  list,
  detail,
  getPatientList,
  create,
  update,
  getPatientReports,
  changeStatus,
  destroy,
  addCenter,
  addMedicalStaff,
  addHealthConditions,
  verifyEmail,
  tugTimeGraphic,
  getHDM,
  documents,
  addOneMedicalStaff,
  removeOneMedicalStaff,
  sendEmail,
  sendLegalDocuments,
  sendSmartDetect,
  associateAll,
  documentPatient,
  getVDSIList,
  sendEmailVdsi,
  getTeleconsultations,
  getQuestionnaireDates,
  getMessageHistory,
  getTokenCertipair,
  postLoginCartipair,
  getSearchConseils,
  getUtilsConseils,
  getConseilsFavorites,
  postConseilsSend,
  changeFavorite,
  getPatientsFile,
  createOmnidoc,
}
